<template>
    <div class="index-idea-box">
        <div class="index-idea-info" @click="goIdea">
            <img class="img" :src="$imgUrlFilter(props.ideaInfo.logo, 200, 200)" />
            <div>
                <strong class="render-line-clamp">{{ props.ideaInfo.title }}</strong>
                <div class="types">
                    <span class="l">创意ID {{props.ideaInfo.idea_id}}</span>
                    <span>类型 {{props.ideaInfo.category}}</span>
                </div>
            </div>
        </div>
        <div class="address-box">
            <span>创意链接快捷跳转众筹</span>
            <el-tooltip effect="dark" placement="top">
                <template #content>
                    <p>创意的分享链接打开后在创意基础上自动跳转到“众筹详情”，“众筹详情”<br/>
                        返回后可见“创意详情”，该创意的快捷跳转默认打开，可手动关闭。</p>
                </template>
                <span class="icon-warning icon cursor"></span>
            </el-tooltip>
            <el-switch 
                v-model="state.switch"
                :before-change="beforeChangeColumn"
                @change="switchChange"
                :active-value="1"
                :inactive-value="0"
                active-color="#00C4A1" 
                inactive-color="#B1B1B1"></el-switch>
        </div>
    </div>
</template>

<script setup>
import { ElMessage } from "element-plus";

import { reactive, defineProps, defineEmits } from "vue";
import { watch } from "@vue/runtime-core";
import '@/utils/tools.js'

import { setIdeaQuickJump } from "@/api/index"
const emit = defineEmits(['close']);
const props = defineProps({
    ideaInfo: Object
})
const state = reactive({
    switch: 0,
    switchState: false
})
watch(() => {[props.ideaInfo]}, () => {
    state.switch = props.ideaInfo.is_set_quick_jump || 0
}, { deep: true, immediate: true })

const beforeChangeColumn = () => {
    state.switchState = true
    return state.switchState
}
const switchChange = () => {
    if (state.switchState) {
        setIdeaQuickJump({
            idea_id: props.ideaInfo.idea_id
        }).then(res => {
            if (res.status == 0){
                state.switch = res.data
                ElMessage({
                    type: 'info',
                    customClass: 'info-customize',
                    message: '操作成功',
                });
            }
        })
    } 
}
const goIdea = () => {
    emit('goIdea');
}

</script>

<style lang="scss" scoped>
.index-idea-box {
    padding-top: 14px;
    .index-idea-info {
        display: flex;
        line-height: 1;
        cursor: pointer;
        .img {
            width: 70px;
            height: 70px;
            border: 1px solid #E8E8E8;
            border-radius: 4px;
            margin-right: 20px;
        }
        strong {
            font-size: 16px;
            line-height: 24px;
        }
        .types {
            color: #7F7F7F;
            margin-top: 7px;
            .l {
                margin-right: 30px;
            }
        }
    }
    .address-box {
        border-top: 1px solid #F2F2F2;
        padding-top: 14px;
        margin-top: 20px;
        margin-bottom: -6px;
        display: flex;
        align-items: center;
        .icon {
            color: #7F7F7F;
            margin: 0 auto 0 5px;
            font-size: 16px;
        }
    }
}
</style>
